package com.dotdrives.web.ui

import react.FC
import react.Props
import react.dom.aria.AriaInvalid
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.textarea
import web.cssom.ClassName
import web.html.InputType
import web.html.text

external interface DotTextFieldProps : Props {
    var value: String
    var onValueChange: (String) -> Unit
    var label: String
    var placeholder: String?
    var error: String?
    var singleLine: Boolean?
    var type: InputType?
    var className: String?
}

val DotTextField = FC<DotTextFieldProps> { props ->
    val fieldClass = listOfNotNull(
        "dot-field",
        "dot-field-error".takeIf { props.error != null },
    ).joinToString(" ")

    label {
        className = ClassName(listOfNotNull("dot-field-wrap", props.className).joinToString(" "))
        span {
            className = ClassName("dot-field-label dot-label")
            +props.label
        }
        if (props.singleLine != false) {
            input {
                className = ClassName(fieldClass)
                value = props.value
                placeholder = props.placeholder ?: ""
                type = props.type ?: InputType.text
                ariaInvalid = (props.error != null).unsafeCast<AriaInvalid>()
                onChange = { event -> props.onValueChange(event.currentTarget.value) }
            }
        } else {
            textarea {
                className = ClassName(fieldClass)
                value = props.value
                placeholder = props.placeholder ?: ""
                ariaInvalid = (props.error != null).unsafeCast<AriaInvalid>()
                onChange = { event -> props.onValueChange(event.currentTarget.value) }
            }
        }
        props.error?.let { message ->
            span {
                className = ClassName("dot-field-message dot-meta")
                +message
            }
        }
    }
}
